{
  "EQUAL_WEIGHTS": {
    "E1": {
      "N": 10,
      "P": 10
    },
    "E2": {
      "N": 10,
      "P": 10
    },
    "E3": {
      "N": 10,
      "P": 10
    },
    "E4": {
      "N": 10,
      "P": 10
    },
    "E5": {
      "N": 10,
      "P": 10
    },
    "H1": {
      "N": 10,
      "P": 10
    },
    "H2": {
      "N": 10,
      "P": 10
    },
    "H3": {
      "N": 10,
      "P": 10
    },
    "H4": {
      "N": 10,
      "P": 10
    },
    "H5": {
      "N": 10,
      "P": 10
    },
    "S1": {
      "N": 10,
      "P": 10
    },
    "S2": {
      "N": 10,
      "P": 10
    },
    "S3": {
      "N": 10,
      "P": 10
    },
    "S4": {
      "N": 10,
      "P": 10
    },
    "S5": {
      "N": 10,
      "P": 10
    },
    "K1": {
      "N": 10,
      "P": 10
    },
    "K2": {
      "N": 10,
      "P": 10
    },
    "K3": {
      "N": 10,
      "P": 10
    },
    "K4": {
      "N": 10,
      "P": 10
    }
  },
  "FINLAND": {
    "E1": {
      "N": 8.26394,
      "P": 8.26394
    },
    "E2": {
      "N": 6.3976,
      "P": 6.3976
    },
    "E3": {
      "N": 0.19,
      "P": 0.19
    },
    "E4": {
      "N": 0.418,
      "P": 0.418
    },
    "E5": {
      "N": 0.456,
      "P": 0.456
    },
    "H1": {
      "N": 8.626,
      "P": 8.626
    },
    "H2": {
      "N": 8.626,
      "P": 8.626
    },
    "H3": {
      "N": 1.216,
      "P": 1.216
    },
    "H4": {
      "N": 1.045,
      "P": 1.045
    },
    "H5": {
      "N": 2.204,
      "P": 2.204
    },
    "S1": {
      "N": 13.623,
      "P": 13.623
    },
    "S2": {
      "N": 6.175,
      "P": 6.175
    },
    "S3": {
      "N": 49.001,
      "P": 49.001
    },
    "S4": {
      "N": 54.606,
      "P": 54.606
    },
    "S5": {
      "N": 7.999,
      "P": 7.999
    },
    "K1": {
      "N": 0,
      "P": 0
    },
    "K2": {
      "N": 0,
      "P": 0
    },
    "K3": {
      "N": 7.847,
      "P": 7.847
    },
    "K4": {
      "N": 13.319,
      "P": 13.319
    }
  },
  "FIGHTING_CLIMATE_CHANGE": {
    "E1": {
      "N": 28.5,
      "P": 47.5
    },
    "E2": {
      "N": 14.25,
      "P": 23.75
    },
    "E3": {
      "N": 14.25,
      "P": 23.75
    },
    "E4": {
      "N": 14.25,
      "P": 23.75
    },
    "E5": {
      "N": 14.25,
      "P": 23.75
    },
    "H1": {
      "N": 5.428571429,
      "P": 5.428571429
    },
    "H2": {
      "N": 5.428571429,
      "P": 5.428571429
    },
    "H3": {
      "N": 5.428571429,
      "P": 5.428571429
    },
    "H4": {
      "N": 5.428571429,
      "P": 5.428571429
    },
    "H5": {
      "N": 5.428571429,
      "P": 5.428571429
    },
    "S1": {
      "N": 5.428571429,
      "P": 5.428571429
    },
    "S2": {
      "N": 5.428571429,
      "P": 5.428571429
    },
    "S3": {
      "N": 5.428571429,
      "P": 5.428571429
    },
    "S4": {
      "N": 5.428571429,
      "P": 5.428571429
    },
    "S5": {
      "N": 5.428571429,
      "P": 5.428571429
    },
    "K1": {
      "N": 5.428571429,
      "P": 5.428571429
    },
    "K2": {
      "N": 5.428571429,
      "P": 5.428571429
    },
    "K3": {
      "N": 5.428571429,
      "P": 5.428571429
    },
    "K4": {
      "N": 5.428571429,
      "P": 5.428571429
    }
  },
  "HEALTH_FIRST": {
    "E1": {
      "N": 5.428571429,
      "P": 5.428571429
    },
    "E2": {
      "N": 5.428571429,
      "P": 5.428571429
    },
    "E3": {
      "N": 5.428571429,
      "P": 5.428571429
    },
    "E4": {
      "N": 5.428571429,
      "P": 5.428571429
    },
    "E5": {
      "N": 5.428571429,
      "P": 5.428571429
    },
    "H1": {
      "N": 28.5,
      "P": 28.5
    },
    "H2": {
      "N": 28.5,
      "P": 28.5
    },
    "H3": {
      "N": 19,
      "P": 19
    },
    "H4": {
      "N": 19,
      "P": 19
    },
    "H5": {
      "N": 19,
      "P": 19
    },
    "S1": {
      "N": 5.428571429,
      "P": 5.428571429
    },
    "S2": {
      "N": 5.428571429,
      "P": 5.428571429
    },
    "S3": {
      "N": 5.428571429,
      "P": 5.428571429
    },
    "S4": {
      "N": 5.428571429,
      "P": 5.428571429
    },
    "S5": {
      "N": 5.428571429,
      "P": 5.428571429
    },
    "K1": {
      "N": 5.428571429,
      "P": 5.428571429
    },
    "K2": {
      "N": 5.428571429,
      "P": 5.428571429
    },
    "K3": {
      "N": 5.428571429,
      "P": 5.428571429
    },
    "K4": {
      "N": 5.428571429,
      "P": 5.428571429
    }
  },
  "KNOWLEDGE_FIRST": {
    "E1": {
      "N": 10.13333333,
      "P": 10.13333333
    },
    "E2": {
      "N": 10.13333333,
      "P": 10.13333333
    },
    "E3": {
      "N": 10.13333333,
      "P": 10.13333333
    },
    "E4": {
      "N": 10.13333333,
      "P": 10.13333333
    },
    "E5": {
      "N": 10.13333333,
      "P": 10.13333333
    },
    "H1": {
      "N": 10.13333333,
      "P": 10.13333333
    },
    "H2": {
      "N": 10.13333333,
      "P": 10.13333333
    },
    "H3": {
      "N": 10.13333333,
      "P": 10.13333333
    },
    "H4": {
      "N": 10.13333333,
      "P": 10.13333333
    },
    "H5": {
      "N": 10.13333333,
      "P": 10.13333333
    },
    "S1": {
      "N": 10.13333333,
      "P": 10.13333333
    },
    "S2": {
      "N": 10.13333333,
      "P": 10.13333333
    },
    "S3": {
      "N": 10.13333333,
      "P": 10.13333333
    },
    "S4": {
      "N": 10.13333333,
      "P": 10.13333333
    },
    "S5": {
      "N": 10.13333333,
      "P": 10.13333333
    },
    "K1": {
      "N": 19,
      "P": 95
    },
    "K2": {
      "N": 19,
      "P": 95
    },
    "K3": {
      "N": 19,
      "P": 95
    },
    "K4": {
      "N": 19,
      "P": 95
    }
  },
  "TAXES_AND_JOBS": {
    "E1": {
      "N": 5.588235294,
      "P": 11.17647059
    },
    "E2": {
      "N": 5.588235294,
      "P": 11.17647059
    },
    "E3": {
      "N": 5.588235294,
      "P": 11.17647059
    },
    "E4": {
      "N": 5.588235294,
      "P": 11.17647059
    },
    "E5": {
      "N": 5.588235294,
      "P": 11.17647059
    },
    "H1": {
      "N": 5.588235294,
      "P": 11.17647059
    },
    "H2": {
      "N": 5.588235294,
      "P": 11.17647059
    },
    "H3": {
      "N": 5.588235294,
      "P": 11.17647059
    },
    "H4": {
      "N": 5.588235294,
      "P": 11.17647059
    },
    "H5": {
      "N": 5.588235294,
      "P": 11.17647059
    },
    "S1": {
      "N": 47.5,
      "P": 95
    },
    "S2": {
      "N": 47.5,
      "P": 95
    },
    "S3": {
      "N": 5.588235294,
      "P": 11.17647059
    },
    "S4": {
      "N": 5.588235294,
      "P": 11.17647059
    },
    "S5": {
      "N": 5.588235294,
      "P": 11.17647059
    },
    "K1": {
      "N": 11.17647059,
      "P": 11.17647059
    },
    "K2": {
      "N": 5.588235294,
      "P": 11.17647059
    },
    "K3": {
      "N": 5.588235294,
      "P": 11.17647059
    },
    "K4": {
      "N": 5.588235294,
      "P": 11.17647059
    }
  }
}